import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, FormWrapper } from "./CreateMembersStyles";
//import { FaEye, FaEyeSlash } from "react-icons/fa";

import { getRoles, createMember } from "../../../redux/slices/userSlice";

const CreateMembers = ({ loading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { roles } = useSelector((state) => state.user);
  //console.log(roles)

  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    //password: "",
    skype: "",
    phoneNumber: "",
    companyName: "",
    location: "",
    role: "",
  });
  // const [showPassword, setShowPassword] = useState(false);
  // const toggleType = () => {
  //   setShowPassword(!showPassword);
  // };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    //dispatch(createMember(formData));
    try {
      const result = await dispatch(createMember(formData)).unwrap();
      if (result.statusCode === 201) { // Assuming `statusCode` indicates success
        navigate("/profile");
      } else {
        // Handle API errors if needed
        console.error("Failed to create profile:", result.message);
      }
    } catch (error) {
      console.error("Error creating profile:", error);
    }
  };

  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Add User</h3>
          <p>
            Create a new user account with customized access and permissions.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <FormWrapper>
          <label htmlFor="firstName">First name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            placeholder="First name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="lastName">Last name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            placeholder="Last name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="email">Email</label>
          <input
            type="text"
            id="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="phoneNumber">Phone number</label>
          <input
            type="number"
            id="phoneNumber"
            name="phoneNumber"
            placeholder="Phone number"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="skype">Skype ID</label>
          <input
            type="text"
            id="skype"
            name="skype"
            placeholder="Skype ID"
            value={formData.skype}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="companyName">Company Name</label>
          <input
            type="text"
            id="companyName"
            name="companyName"
            placeholder="Company Name"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            placeholder="Location"
            value={formData.location}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="role">Role</label>
          <select
            id="role"
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
          >
            <option value="">Select role</option>
            {Object.entries(roles).map(([key, value]) => (
              <option key={key} value={key}>
                {value}
              </option>
            ))}
          </select>
        </FormWrapper>

        <div className="submit">
          <div></div>
          <div className="submit-buttons">
            <button className="add-campaign" type="submit" disabled={loading}>
              {loading ? "Creating..." : "Create"}
            </button>
          </div>
        </div>
      </form>
    </Container>
  );
};

export default CreateMembers;
